// extracted by mini-css-extract-plugin
module.exports = {"filter":"SideBarFilterBO_filter__2FdNh","wrap":"SideBarFilterBO_wrap__dJIQ7"};